import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { domainUrl } from "../../../constants/apiconstans/domanUrl";
import { message } from "antd";
import { checkAuthorization } from "../../../helpers";

let refreshTimer = null; // Store the timer reference

const startRefreshTimer = (dispatch) => {
  clearTimeout(refreshTimer);
  refreshTimer = setTimeout(
    async () => {
      // try {
      //     const newToken = await dispatch(refreshToken()).unwrap();
      //     if (!newToken) {
      //         dispatch(loginClear());
      //         message.error("Session expired. Please log in again.");
      //     }
      // } catch (error) {
      //     dispatch(loginClear());
      //     message.error("Session expired. Please log in again.");
      // }
    },
    4 * 60 * 1000,
  ); // 4 minutes timer
};

// Helper function for fetching with token refresh
const fetchWithAuth = async (url, options, dispatch) => {
  let response = await fetch(url, options);

  if (response.status === 401) {
    // Token expired, try to refresh once
    try {
      const newToken = await dispatch(refreshToken()).unwrap();

      if (newToken) {
        // Update headers with new token
        localStorage.setItem("token", JSON.stringify(newToken));
        options.headers = new Headers(options.headers);
        options.headers.set("Authorization", `Bearer ${newToken}`);

        // Retry the original request with the new token
        response = await fetch(url, options);
      } else {
        throw new Error("Token refresh failed");
      }
    } catch (error) {
      localStorage.clear(); // Clear storage if refresh fails
      return null;
    }
  }

  return response.json();
};

export const login = createAsyncThunk("login", async (data, { dispatch }) => {
  dispatch(getting());
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify(data),
  };

  fetch(domainUrl + "/login", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if (result.success) {
        //
        localStorage.setItem("refreshToken", result?.user?.refreshToken);
        localStorage.setItem("tokenExpiry", result?.user?.tokenExpire);
        //
        localStorage.setItem("token", result?.user?.token);
        localStorage.setItem("tokenExpire", result?.user?.tokenExpire);
        localStorage.setItem(
          "roleName",
          JSON.stringify(result?.user?.role_name),
        );
        localStorage.setItem("roleId", JSON.stringify(result?.user?.role_id));
        localStorage.setItem(
          "permissions",
          JSON.stringify(result?.user?.modules),
        );
        localStorage.setItem("refreshToken", result.user.refreshToken);
        dispatch(loginResponse(result?.user));
        startRefreshTimer(dispatch);
        window.location.href = "/";
        window.location.reload();
      } else throw result?.message;
    })
    .catch((error) => {
      message.error(error);
      dispatch(loginClear());
    });
});

export const AuthCheck = createAsyncThunk(
  "LoginCheck",
  async (_, { dispatch }) => {
    try {
      const { userToken } = checkAuthorization();
      if (!userToken) throw new Error("No token found");

      dispatch(gettingLoginCheck());

      const myHeaders = new Headers();
      myHeaders.append("Authorization", userToken);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      const result = await fetchWithAuth(
        domainUrl + `/loginCheck`,
        requestOptions,
        dispatch,
      );

      if (result?.success) {
        dispatch(loginResponse(result?.user));
        startRefreshTimer(dispatch); // Start refresh timer after checking auth
      } else {
        dispatch(loginClear());
      }
    } catch (error) {
      dispatch(loginClear());
      message.error("Session expired. Please log in again.");
    }
  },
);

// Refresh Token
export const refreshToken = createAsyncThunk(
  "refreshToken",
  async (_, { dispatch }) => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) throw new Error("Refresh token not found");

    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken }),
      };

      const response = await fetch(domainUrl + "/refreshToken", requestOptions);
      const result = await response.json();

      if (result.success) {
        localStorage.setItem("token", JSON.stringify(result?.user?.token));
        dispatch(loginResponse({ token: result.user.token }));
        return result?.user.token;
      } else {
        throw new Error(result.message || "Failed to refresh token");
      }
    } catch (error) {
      localStorage.clear(); // Clear storage if refresh fails
      return null;
    }
  },
);

export const forgotPassword = createAsyncThunk(
  "forgot",
  async (data, { dispatch }) => {
    dispatch(getting());
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify(data),
    };

    fetch(domainUrl + "/forgotPassword", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          message.success(result?.message || "OTP sent to your email.");
          dispatch(forgotPasswordResponse(result));
        } else {
          throw result?.message;
        }
      })
      .catch((error) => {
        dispatch(loginClear());
        message.error(error);
      });
  },
);

export const otpVerify = createAsyncThunk(
  "otpVerify",
  async (data, { dispatch }) => {
    dispatch(getting());
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify(data),
    };

    fetch(domainUrl + "/verifyOtp", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          message.success(result?.message || "OTP verified successfully.");
          dispatch(otpResponse(result?.token));
        } else {
          throw result?.message;
        }
      })
      .catch((error) => {
        message.error(error || "OTP verification failed");
        dispatch(loginClear());
      });
  },
);

export const resetPassword = createAsyncThunk(
  "resetPassword",
  async ({ data, navigate }, { dispatch }) => {
    dispatch(getting());
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify(data),
    };

    fetch(domainUrl + "/resetPassword", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          message.success(result?.message || "Password reset successfully.");
          navigate("/login");
          dispatch(resetResponse(result));
        } else {
          throw result?.message;
        }
      })
      .catch((error) => {
        message.error(error || "Password reset failed");
        dispatch(loginClear());
      });
  },
);

const loginSlice = createSlice({
  name: "login",
  initialState: {
    loginData: null,
    loading: false,
    LoginCheckloading: false,
    otpToken: null,
    token: localStorage.getItem("token") || null,
    requestState: "request",
  },
  reducers: {
    getting: (state) => {
      state.loading = true;
    },
    loginResponse: (state, action) => {
      state.loginData = action.payload;
      state.token = action.payload.token;
      state.loading = false;
      state.LoginCheckloading = false;
    },
    loginClear: (state) => {
      state.loginData = null;
      state.token = null;
      state.loading = false;
      state.LoginCheckloading = false;
      clearTimeout(refreshTimer);
      window.location.href = "/"; // Redirect on logout
    },
    gettingLoginCheck: (state) => {
      state.LoginCheckloading = true;
    },
    forgotPasswordResponse: (state, action) => {
      state.loginData = action.payload;
      state.requestState = "otp";
      state.loading = false;
    },
    otpResponse: (state, action) => {
      state.otpToken = action.payload;
      state.requestState = "reset";
      state.loading = false;
    },
    resetResponse: (state, action) => {
      state.loginData = action.payload;
      state.loading = false;
      state.token = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refreshToken.fulfilled, (state, action) => {
        if (action.payload) {
          state.token = action.payload;
        }
      })
      .addCase(refreshToken.rejected, (state) => {
        state.token = null;
      });
  },
});

export const {
  getting,
  loginResponse,
  loginClear,
  gettingLoginCheck,
  forgotPasswordResponse,
  otpResponse,
  resetResponse,
} = loginSlice.actions;
export default loginSlice.reducer;
